import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { CardInterface, ConfigInterface, StepperInterface, WebConfigInterface } from 'projects/apna-lib/src/lib/interfaces/common-interface';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { ConfigService } from 'projects/apna-lib/src/lib/services/config.service';
import { LoanGtmService } from 'projects/apna-lib/src/lib/services/loan-gtm.service';
import { UserIdentityService } from 'projects/apna-lib/src/lib/services/user-identity.service';

@Component({
  selector: 'fa-application-status',
  templateUrl: './application-status.component.html',
  styleUrls: ['./application-status.component.scss']
})

export class ApplicationStatusComponent implements OnInit {
  isPartnerLink: boolean = false;
  loanApplicationVendors: any[];
  partnerLogo: string;
  @ViewChild('content') content: any;
  @ViewChild('requestSentSuccessMsg') requestSentSuccessMsg: TemplateRef<any>;
  loanWidgetConfig: any = this.configService.getConfig1("loanWidgetConfig");
  isExpanded: boolean[] = [];
  config: ConfigInterface = this.loanWidgetConfig?.applicationStatusHeaderConfig;
  cardConfig: CardInterface = this.loanWidgetConfig?.applicationStatusSingleCardConfig;
  webCardConfig: CardInterface = this.loanWidgetConfig?.applicationStatusSingleWebCardConfig;
  steps: StepperInterface = this.loanWidgetConfig?.uploadDocStepperConfig;
  vendorUserDetails: any;
  canLogout: boolean = true;
  loading: boolean = false;
  showIds: any[] = [];
  statusIcon: any = this.loanWidgetConfig?.applicationStatusIcon;
  statusClass: any = this.loanWidgetConfig?.applicationStatusClass;
  webData: WebConfigInterface = this.loanWidgetConfig?.uploadDocWebHeaderConfig;
  webConfig: WebConfigInterface = this.loanWidgetConfig?.uploadDocWebHeaderConfig;
  constructor(
    public loanService: LoanGtmService,
    private configService: ConfigService,
    private route: Router,
    private userIdentity: UserIdentityService,
    private apiHelper: ApiHelperService,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
  ) {

  }

  ngOnInit(): void {
    this.spinner.hide();
    const puid = this.activatedRoute.snapshot.paramMap.get('puid');
    if (puid) {
      this.config["logout"] = `/${puid}`
      this.webData["logout"] = `/${puid}`;
      this.cardConfig.singleCardData.href = `/upload-documents/${puid}`
      this.webCardConfig.singleCardData.href = `/upload-documents/${puid}`
      localStorage.setItem('puid', puid);
      this.isPartnerLink = true;
      if (!this.loanService?.partnerDetails) {
        this.getPartnerDetails(puid);
      }
      else {
        this.webData = {
          ...this.webData,
          isPartnerLogo:true,
          logo: this.loanService.partnerDetails?.company?.showCompanyLogo ? this.loanService?.partnerDetails?.company?.logo : undefined
        }
        this.partnerLogo = this.loanService.partnerDetails?.company?.showCompanyLogo ? this.loanService?.partnerDetails?.company?.logo : undefined;
        this.checkUserLoggedIn(puid);
      }
    }
    else {
      this.cardConfig.singleCardData.href = `/upload-documents`
      this.webCardConfig.singleCardData.href = `/upload-documents`
      this.config["logout"] = "/"
      this.webData["logout"] = `/`;
    }
    this.checkUserLoggedIn(puid);

  }

  requestACallback(vendorUserName: any, assignedToId: string, name: string, studentId: string) {

    this.apiHelper.postData('send-request-a-call-back', { vendorUserName: vendorUserName, assignedToId: assignedToId, vendorName: name, id: studentId }).subscribe((result: any) => {
      console.log(result)
    })

    this.modalService.open(this.requestSentSuccessMsg, {
      centered: true,
      size: 'xxl'
    })
  }
  copied() {
    this.apiHelper.openSnackBar("Copied Details SuccessFully!")
  }

  getPartnerDetails(partnerUid: string) {
    this.apiHelper.getDataById("users/partner", partnerUid)?.subscribe({
      next: (response: any) => {
        // Handle successful response
        let partnerDetails = { ...response };
        localStorage.setItem('puid', partnerUid);
        this.loanService.studentDetails.parentId = partnerDetails?.id;
        this.loanService.partnerDetails = { ...partnerDetails };
        this.loanService.studentDetails.puid = partnerDetails?.uid;
        this.partnerLogo = partnerDetails?.company?.showCompanyLogo ? partnerDetails?.company?.logo : undefined;
        this.webData = {
          ...this.webData,
          isPartnerLogo:true,
          logo: partnerDetails?.company?.showCompanyLogo ? partnerDetails?.company?.logo : undefined
        }
      },
      error: (error: any) => {
        this.route.navigate(['/application-status'])
        this.isPartnerLink = false;
      }
    });

  }
  checkUserLoggedIn(puid: any) {
    if (this.activatedRoute.snapshot.queryParams?.hasOwnProperty("referenceId") && this.activatedRoute?.snapshot.queryParams.hasOwnProperty("token")) {
      const referenceId = this.activatedRoute?.snapshot?.queryParams?.referenceId;
      const applicationId = this.activatedRoute?.snapshot?.queryParams?.apxId;
      const token = this.activatedRoute?.snapshot?.queryParams?.token
      this.loanService.getStudentDetailsById(referenceId).then((data: any) => {
        const userDetails = { ...data[0] }
        this.loanService.saveStudentDetails(data[0]);
        localStorage.setItem("userDetails", JSON.stringify(userDetails));
        localStorage.setItem("token", token);
        localStorage.setItem("userId", referenceId);
        localStorage.setItem("ttl", "3600");
        this.canLogout = false;
        this.config["logout"] = undefined;
        this.config["backLink"] = undefined;
        this.webData["backLink"] = undefined;
        this.webData["logout"] = undefined;
        if (applicationId) {
          this.apiHelper.getData("loan-application-vendor", { where: { loanApplicationId: applicationId } })
            .then((data: any) => {
              this.loanApplicationVendors = [...data];
              this.loanService.loanDetails = Object.assign(this.loanService.loanDetails, { ...data[0].loanApplication })
              this.webData = {
                ...this.webData,
                loan: {
                  loanType: this.loanService?.loanDetails?.loanType,
                  loanAmount: this.loanService?.loanDetails?.loanAmount,
                  loanAmountCurrency: this.loanService?.loanDetails?.loanAmountCurrency
                }
              }
              this.loanApplicationVendors.forEach(() => {
                this.isExpanded.push(false);
              });
            })
        }
      })

    }
    else if (!this.loanService.studentDetails?.mobile) {
      if (this.isPartnerLink) {
        this.route.navigate(['/' + puid]);
        return;
      }
      this.route.navigate(['']);
      return;
    }
    else if (!this.userIdentity.isLoggedIn.getValue()) {
      if (this.isPartnerLink) {
        this.route.navigate(['/' + puid]);
        return;
      }
      this.route.navigate(['']);
      return;
    }
    else if (!this.loanService?.loanDetails?.id) {
      if (this.isPartnerLink) {
        this.route.navigate(['/' + puid]);
        return;
      }
      this.route.navigate(['']);
      return;
    }
    else {
      this.loading = true;
      this.apiHelper.getData("loan-application-vendor", { where: { loanApplicationId: this.loanService?.loanDetails?.id } })
        .then((data: any) => {
          this.loading = false;
          this.loanApplicationVendors = [...data];
          const userDetails = { ...data[0]?.student }
          this.loanService.saveStudentDetails(data[0]?.student);
          localStorage.setItem("userDetails", JSON.stringify(userDetails));
          this.loanService.loanDetails = Object.assign(this.loanService.loanDetails, { ...data[0]?.loanApplication })
          this.webData = {
            ...this.webData,
            loan: {
              loanType: this.loanService?.loanDetails?.loanType,
              loanAmount: this.loanService?.loanDetails?.loanAmount,
              loanAmountCurrency: this.loanService?.loanDetails?.loanAmountCurrency
            }
          }
          this.loanApplicationVendors.forEach(() => {
            this.isExpanded.push(false);
          });
        })
    }
  }

  uploadDocs() {
    if (this.isPartnerLink) {
      this.route.navigate(['/upload-documents/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['/upload-documents']);
  }

  raiseARequest() {
    this.modalService.open(this.content, { centered: true });
    let loanRequest: any = {
      id: this.loanService?.studentDetails?.id,
      name: `${this.loanService.studentDetails?.firstName + " " + this.loanService.studentDetails?.lastName}`,
      email: this.loanService.studentDetails?.email,
      mobile: this.loanService.studentDetails?.mobile,
      loanType: this.loanService.loanDetails?.loanType
    };

    if (this.isPartnerLink) {
      loanRequest.partnerName = this.loanService?.partnerDetails?.name;
      loanRequest.showAgentCode = this.loanService?.partnerDetails?.company?.showAgentCode ? true : false
    }
    this.apiHelper.postData("send-loan-application-request", loanRequest).subscribe(() => {
      this.apiHelper.openSnackBar("Sent request Successfully!");
    })
  }

  clearDetails() {
    this.loanService.setDefaultDetails();
    if (this.isPartnerLink) {
      this.route.navigate(['' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate([''])
  }
  logout() {
    if (this.isPartnerLink) {
      this.route.navigate(['/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['/'])
  }

  completeTheApplication(vendorName: string) {
    let dataObj: any = {
      studentId: this.loanService?.studentDetails?.id,
      studentName: this.loanService?.studentDetails?.firstName + " " + this.loanService?.studentDetails?.lastName,
      userType: 'student',
      userId: this.loanService?.studentDetails?.id,
      userName: this.loanService?.studentDetails?.firstName + " " + this.loanService?.studentDetails?.lastName,
      vendorName: vendorName,
    }
    this.apiHelper.postData('audit-logs/create-application-logs', dataObj).subscribe((res: any) => {
      console.log(res)
    })
  }
  prepareViewLoanAmount(amount: string) {
    return (Number((amount))).toLocaleString('en-IN', {
      maximumFractionDigits: 2,
      currency: 'INR'
    }).replace("$", "").split(".")[0].toString();
  }

  routeToDocs() {
    console.log(this.isPartnerLink, 228)
    if (this.isPartnerLink) {
      this.route.navigate(['/upload-documents/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['/upload-documents'])
  }

  toggleView(index: number) {
    this.isExpanded[index] = !this.isExpanded[index];
  }
}
